import { useEffect } from 'react';

import { useToggleLayoutPlatform } from '@/utils/zustand/providers/toggle-layout-platform-provider';
import useDarkMode from '@/utils/hooks/utils/useDarkMode';

import { LayoutPlatform } from '@/components/layouts/LayoutPlatform';
import { WrapperPlatformContent } from '@/components/layouts/wrappers/WrapperPlatformContent';
import { AccessControl } from '@/components/middleware/AccessControl';
import { PaddleInitialize } from '@/components/tools/Paddle';

export type WrapperPlatformProps = {
    noPadding?: boolean;
    disableMainScroll?: boolean;
    className?: string;
    children: React.ReactNode;
};

export function WrapperPlatform({
    noPadding = false,
    disableMainScroll = false,
    className,
    children
}: WrapperPlatformProps) {
    const { useAddDarkMode } = useDarkMode();

    const updatePlatformLayout = useToggleLayoutPlatform((state) => state.updatePlatformLayout);

    useEffect(() => {
        updatePlatformLayout?.(true);
        return () => updatePlatformLayout(false);
    }, []);

    // Launch theme
    useAddDarkMode();

    return (
        <LayoutPlatform>
            <AccessControl>
                <WrapperPlatformContent
                    className={className}
                    noPadding={noPadding}
                    disableMainScroll={disableMainScroll}>
                    {children}
                </WrapperPlatformContent>
            </AccessControl>
            <PaddleInitialize />
        </LayoutPlatform>
    );
}
